import { useWidgetStore } from "@/state";

// resolves when triggerEl becomes available
export const waitForTrigger = (opts?: { allowManual?: boolean }) =>
  new Promise<void>((resolve) => {
    const snap = useWidgetStore.getState();

    // AUTO: trigger button exists
    if (snap.triggerEl) return resolve();

    // MANUAL: allow proceeding if we can anchor to hostEl
    if (opts?.allowManual && snap.hostEl) return resolve();

    const unsub = useWidgetStore.subscribe((next, prev) => {
      if (!prev.triggerEl && next.triggerEl) {
        unsub();
        resolve();
        return;
      }

      if (opts?.allowManual && !prev.hostEl && next.hostEl) {
        unsub();
        resolve();
      }
    });
  });

export const waitForPublicStateReady = async () => {
  if (useWidgetStore.getState().state.ready) return;

  const p = window.TelekomIdWidget?.widgetReady;
  if (p) {
    await p;
    return;
  }

  await new Promise<void>((resolve) => {
    if (useWidgetStore.getState().state.ready) {
      resolve();
      return;
    }

    const unsub = useWidgetStore.subscribe((next, prev) => {
      if (!prev.state.ready && next.state.ready) {
        unsub();
        resolve();
      }
    });
  });
};

export const tryOpenMenu = (tries = 0) => {
  const ui = useWidgetStore.getState();

  // 1) AUTO: prefer trigger button
  if (ui.triggerEl) {
    ui.setMenuAnchorEl(ui.triggerEl);
    return;
  }

  // 2) MANUAL: anchor to hostEl (this is the div the channel passed)
  if (ui.hostEl) {
    ui.setMenuAnchorEl(ui.hostEl);
    return;
  }

  if (tries < 60) {
    requestAnimationFrame(() => tryOpenMenu(tries + 1));
    return;
  }

  ui.setMenuAnchorEl(ui.portalContainer ?? document.body);
};

export const forceHostVisibleEl = (host: HTMLElement) => {
  if (host.dataset.cosidForcedDisplay === "1") return;

  host.dataset.cosidPrevDisplay = host.style.display || "";
  host.dataset.cosidForcedDisplay = "1";

  host.style.display = "block";
  host.style.visibility = "visible";
};

export const restoreHostDisplayIfForced = (host: HTMLElement) => {
  if (host.dataset.cosidForcedDisplay === "1") {
    host.style.display = host.dataset.cosidPrevDisplay ?? "";
    delete host.dataset.cosidForcedDisplay;
    delete host.dataset.cosidPrevDisplay;
  }
};
